export default __webpack_public_path__ + "static/investors-in-people-414b8415b9fb7b4027a3c484a283f2ba.png";